import {ApolloClient, ApolloLink, HttpLink, InMemoryCache} from "@apollo/client";
import {Config} from "../config/Config";

const settings: Config = require('../config/config.json')

const httpLink = new HttpLink({
    uri: settings.apiPath,
})

export default function createClient() {
    const middlewareLink = new ApolloLink((operation, forward) => {
        const token = window.localStorage.getItem('keycloakToken')
        operation.setContext({
            headers: {
                'Authorization': token ? `Bearer ${token}` : '',
                //'x-hasura-role': 'user',
            }
        })
        return forward(operation)
    })

    // use with apollo-client
    const link = middlewareLink.concat(httpLink)

    // clean __typename, but preserve cache update (better solution than addTypename: false
    const cleanTypeName = new ApolloLink((operation, forward) => {
        if (operation.variables) {
            const omitTypename = (key: string, value: any) => (key === '__typename' ? undefined : value)
            operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename)
        }
        return forward(operation).map((data) => {
            return data;
        })
    })

    const cleanLink = cleanTypeName.concat(link)

    return new ApolloClient({
        link: cleanLink,
        cache: new InMemoryCache({
            //addTypename: false
        })
    })
}
